import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { CarteiraAdminService } from '../../../services/carteiraAdmin/carteiraAdminService';
import { CARTEIRA_PERMISSAO_GET, CARTEIRA_USUARIO_GET, CARTEIRA_PERMISSAO_UPDATE } from '../../../types/carteiraAdmin/carteiraAdmin';
import { AppThunk, DispatchPaged, DispatchPagedReset } from 'base/src/utils/reducerUtil';
import { CarteiraPermissaoResponse } from '../../../types/carteiraAdmin/carteiraPermissaoResponse';
import { PagedListRequest } from 'domain/types/global/pagedListRequest';
import { TFunction } from 'i18next';
import { UsuarioCarteiraResponse } from '../../../types/carteiraAdmin/carteiraUsuarioResponse';
import { PagedListResponse } from 'domain/types/global/pagedListResponse';
import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';
import { UpdateCarteiraPermissaoRequest } from '../../../types/carteiraAdmin/updateCarteiraPermissaoRequest';
import { CarteiraPermissaoTipo } from 'domain/types/_carteira/carteiraAdmin/carteiraPermissaoTipo';
const _CarteiraAdminService = new CarteiraAdminService();
export function GetCarteiraPermissao(carteiraId : number): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(CARTEIRA_PERMISSAO_GET, DispatchType.LOADING, undefined, undefined,
        () => { dispatch(GetCarteiraPermissao(carteiraId)) }))
    
        
        const asyncResponse: CarteiraPermissaoResponse | Error = await _CarteiraAdminService.GetCarteiraPermissao(carteiraId, CARTEIRA_PERMISSAO_GET)
        if (ResponseValid(asyncResponse)) {
            dispatch({
                payload: asyncResponse,
                type: CARTEIRA_PERMISSAO_GET
            });
        }
    };
}


export function GetUsuariosCarteira(carteiraId:number, empresaId: number, request: PagedListRequest<UsuarioCarteiraResponse>, t: TFunction): AppThunk {
    return async (dispatch) => {

        dispatch(DispatchLoading(CARTEIRA_USUARIO_GET, DispatchType.LOADING, `${t("Carregando")} ${t("Usuarios")}`, undefined,
            () => dispatch(GetUsuariosCarteira(carteiraId, empresaId, request, t))))

        request.data = { EmpresaID: _UserData.Get(UserDataBaseEnum.EmpresaID) } as UsuarioCarteiraResponse

        const asyncResponse: PagedListResponse<UsuarioCarteiraResponse> | Error = await _CarteiraAdminService.GetUsuarioCarteira(carteiraId, request)

        if (ResponseValid(asyncResponse)) {
            const paged = (asyncResponse as PagedListResponse<UsuarioCarteiraResponse>)

            dispatch(DispatchPaged<UsuarioCarteiraResponse>(CARTEIRA_USUARIO_GET, request, paged))
        }
    }
}


export function ResetUsuariosCarteiraPaged(request: PagedListRequest<UsuarioCarteiraResponse>, take :number): AppThunk {
    return async (dispatch) => {
            dispatch(DispatchPagedReset<UsuarioCarteiraResponse>(CARTEIRA_USUARIO_GET, request, take))
    }
}

export function AtualizarPermissaoCarteira(carteiraId: number, usuarioId: number, carteiraPermissaoTipoID: CarteiraPermissaoTipo, status:boolean, t: TFunction): AppThunk {
    return async (dispatch) => {

        const request = { CarteiraID: carteiraId, UsuarioID: usuarioId, CarteiraPermissaoTipoID:carteiraPermissaoTipoID, Status: Number(status) } as UpdateCarteiraPermissaoRequest;

        dispatch(DispatchLoading(CARTEIRA_PERMISSAO_UPDATE, DispatchType.LOADING, `${t("Atualizando")} ${t("Permissao")}`, undefined,
            () => dispatch(AtualizarPermissaoCarteira(carteiraId, usuarioId, carteiraPermissaoTipoID,  status, t))))

        const asyncResponse: boolean | Error = await _CarteiraAdminService.AtualizarPermissao(carteiraId, usuarioId, request, CARTEIRA_PERMISSAO_UPDATE)

        if (ResponseValid(asyncResponse)) {
            dispatch({
                payload: { UsuarioID: usuarioId, Status: status, CarteiraPermissaoTipoID: carteiraPermissaoTipoID },
                type: CARTEIRA_PERMISSAO_UPDATE
            });
        }
    }
}
